import { Injectable } from "@nestjs/common";
import { Repository } from "typeorm";
import { InjectRepository } from "@nestjs/typeorm";
import { RootWiseCostEntity } from "./root-wise-cost.entity";

@Injectable()
export class RootWiseCostRepository extends Repository<RootWiseCostEntity> {

    constructor(@InjectRepository(RootWiseCostEntity) private Columns: Repository<RootWiseCostEntity>
    ) {
        super(Columns.target, Columns.manager, Columns.queryRunner);
    }
}